import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { UploadAddressInfo } from 'pages/upload-info-pages';
import z from 'zod';

const addressInfoSchema = z.object({
  billcodeId: z.string().or(z.number()),
  documentType: z.enum(['PB', 'UB']).optional(),
});

export const Route = createFileRoute('/upload-address-info')({
  component: UploadAddressInfo,
  validateSearch: zodValidator(addressInfoSchema),
});
